module.exports = __webpack_public_path__ + "img/moon.bb94236b.png";